import React from 'react';

export default function Footer(){

    return(
        <footer>
            <a target={"_blank"} className={"footer_links"} href={"http://www.ice.co.il/40under40_2018"}>40 UNDER 40 2018</a>
            <a target={"_blank"} className={"footer_links"} href={"http://www.ice.co.il/40under40_2019"}>40 UNDER 40 2019</a>
        </footer>
    )
}

